export enum GenresEnum {
  Music = 'music',
  Series = 'serie',
  Radio = 'radio',
  Movies = 'movie'
}
export interface GenresModel {
  id?: string;
  _id?: string;
  name: { [key: string]: string };
  image?: string;
}

export interface CategoriesModel {
  id?: string;
  title: string;
  description: string;
}
export interface CategoriesProps {
  loading?: boolean;
  selectedValue: { id: string; name: string; description: string } | null;
  handleSave: (value: any) => void;
}
